import apiClient from '@/core/api/client';
import { API_ENDPOINTS } from '@/core/api/endpoints';
import { TagRequest, TagResponse, TagListResponse } from '../types';

export const tagApi = {
    getTags: async (
        schoolSlug: string,
        params?: {
            page?: number;
            page_size?: number;
            search?: string;
            sort_by?: string;
            sort_order?: 'asc' | 'desc';
        }
    ): Promise<TagListResponse> => {
        try {
            const cleanParams: Record<string, any> = {};
            if (params) {
                if (params.page !== undefined) cleanParams.page = params.page;
                if (params.page_size !== undefined) cleanParams.page_size = params.page_size;
                if (params.search && params.search.trim()) cleanParams.search = params.search.trim();
                if (params.sort_by) cleanParams.sort_by = params.sort_by;
                if (params.sort_order) cleanParams.sort_order = params.sort_order;
            }
            const response = await apiClient.get<TagListResponse>(API_ENDPOINTS.TAGS.LIST(schoolSlug), { params: cleanParams });
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to fetch tags'
            };
        }
    },

    createTag: async (schoolSlug: string, data: TagRequest): Promise<TagResponse> => {
        try {
            const response = await apiClient.post<TagResponse>(API_ENDPOINTS.TAGS.CREATE(schoolSlug), data);
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to create tag'
            };
        }
    },

    updateTag: async (schoolSlug: string, tagId: string, data: TagRequest): Promise<TagResponse> => {
        try {
            const response = await apiClient.patch<TagResponse>(API_ENDPOINTS.TAGS.UPDATE(schoolSlug, tagId), data);
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to update tag'
            };
        }
    },

    deleteTag: async (schoolSlug: string, tagId: string): Promise<TagResponse> => {
        try {
            const response = await apiClient.delete<TagResponse>(API_ENDPOINTS.TAGS.DELETE(schoolSlug, tagId));
            return response.data;
        } catch (error: any) {
            return {
                success: false,
                error: error.response?.data?.error || error.response?.data?.message || 'Failed to delete tag'
            };
        }
    }
};
